export default function MobileBurgerMenu() {
	// mobile burger menu
	let burger = document.querySelector( '.burger' );
	let menu_body = document.querySelector( '.toggle-menu' );
	let body = document.body;
	let main_wrapper = document.querySelector( '.main-wrapper' );
	if ( burger && menu_body ) {
		burger.onclick = function () {
			menu_body.classList.toggle( 'active' );
			burger.classList.toggle( 'active' );
			body.classList.toggle( 'no-scroll' );
			main_wrapper.classList.toggle( 'active-menu' );
		}
	}
}